import { render, staticRenderFns } from "./CommonLanding.vue?vue&type=template&id=09063dbe&scoped=true"
import script from "./CommonLanding.vue?vue&type=script&lang=js"
export * from "./CommonLanding.vue?vue&type=script&lang=js"
import style0 from "./CommonLanding.vue?vue&type=style&index=0&id=09063dbe&prod&scoped=true&lang=css"
import style1 from "./CommonLanding.vue?vue&type=style&index=1&id=09063dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09063dbe",
  null
  
)

export default component.exports